import { render, staticRenderFns } from "./news-notice.vue?vue&type=template&id=45aa76b8&scoped=true&"
import script from "./news-notice.vue?vue&type=script&lang=js&"
export * from "./news-notice.vue?vue&type=script&lang=js&"
import style0 from "./news-notice.vue?vue&type=style&index=0&id=45aa76b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa76b8",
  null
  
)

export default component.exports